import React, { useEffect, useRef } from "react";
import styled, { css } from "styled-components";

// Context
import { useFormSelectDialog } from "core/FormSelectDialog/context/useFormSelectDialog";
import {
    focusPrevOption,
    focusNextOption,
    focusSelectedOption
} from "../utils";

// styles
import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
import { dialogDropShadow } from "core/boxShadows.js";
export const DialogStyled = styled.div`
    position: relative;
    > div {
        margin: 0px;
        padding: 0px;
        width: ${convertPxToRem(300)};
        background-color: ${colors.primary.snow};
        color: ${colors.secondary.oolong};
        box-shadow: ${dialogDropShadow};
        border: 1px solid ${colors.primary.diamond};

        position: absolute;
        z-index: 10;
        top: ${convertPxToRem(5)};

        ${({ $dialogAlignment }) => {
            let styles;

            switch ($dialogAlignment) {
                case "center":
                    styles = css`
                        left: 50%;
                        transform: translate(-50%, 0);
                    `;
                    break;
                case "right":
                    styles = css`
                        right: 0rem;
                    `;
                    break;
                default:
                    styles = css`
                        left: 0rem;
                    `;
                    break;
            }

            return styles;
        }}
    }
`;

// components
import DialogOption from "./DialogOption";

const Dialog = () => {
    const {
        id,
        options,
        isOpen,
        dialogAlignment,
        hasOpenedBefore,
        selectedOption
    } = useFormSelectDialog();

    const optionRefs = useRef([]);

    // side effects
    useEffect(() => {
        const onKeyDown = event => {
            switch (event.key) {
                case "ArrowUp":
                    event.preventDefault();
                    focusPrevOption(optionRefs);
                    break;
                case "ArrowDown":
                    event.preventDefault();
                    focusNextOption(optionRefs);
                    break;
                default:
                    return;
            }
        };

        window.addEventListener("keydown", onKeyDown);

        return () => {
            window.removeEventListener("keydown", onKeyDown);
        };
    }, []);

    useEffect(() => {
        if (isOpen && hasOpenedBefore) {
            focusSelectedOption(optionRefs, selectedOption, options);
        }
    }, [hasOpenedBefore, isOpen]);

    return (
        <DialogStyled $dialogAlignment={dialogAlignment}>
            <div
                role="listbox"
                aria-labelledby={`${id}-dropdown-button`}
                hidden={!isOpen}
                tabIndex={0} // Make listbox focusable
            >
                {options.map((option, idx) => {
                    return (
                        <DialogOption
                            key={option.id}
                            option={option}
                            optionRef={el => (optionRefs.current[idx] = el)}
                        />
                    );
                })}
            </div>
        </DialogStyled>
    );
};

export default Dialog;
